import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToggleService {
  private toggles: Record<string, boolean> = {};

  setToggles(toggles: Record<string, boolean>): void {
    this.toggles = toggles ?? {};
  }

  isEnabled(key: string): boolean {
    return this.toggles[key] === true;
  }
}
